import {Box, ButtonBase} from '@mui/material';
import {messages} from '@smartmixin/i18n';
import {useIntl} from 'react-intl';
import {useLocation} from 'react-router';
import RouterLink from '../../lib/RouterLink';
import {shell} from '../../theme/tokens';
import {useNavItems} from './useNavItems';

/**
 * Phone navigation (<900px): stations, map (forecast maps are one of its
 * modes: see useNavItems), settings —
 * real links, the current one marked aria-current="page" and drawn in ink at
 * 600 with the brand-fill bar above it. At most four slots, with the short
 * labels (navigation.*Short): a quarter of a 360px phone fits every locale's
 * labels, a fifth cut Settings off in six. Help is in the settings index.
 */
const BottomNav = () => {
  const {formatMessage} = useIntl();
  const {pathname} = useLocation();
  const items = useNavItems();
  const entries = [items.stations, items.map, items.settings];
  return (
    <Box
      component="nav"
      aria-label={formatMessage(messages.navigation.main)}
      data-testid="shell-bottom-nav"
      sx={{
        display: {xs: 'flex', md: 'none'},
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        height: `calc(${shell.bottomNavHeight}px + env(safe-area-inset-bottom))`,
        pb: 'env(safe-area-inset-bottom)',
        bgcolor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        zIndex: (t) => t.zIndex.appBar,
      }}>
      {entries.map((item) => {
        const active = item.isActive(pathname);
        return (
          <ButtonBase
            key={item.key}
            component={RouterLink}
            to={item.to}
            aria-current={active ? 'page' : undefined}
            disableRipple
            sx={{
              position: 'relative',
              flex: 1,
              minWidth: 0,
              flexDirection: 'column',
              gap: 0.25,
              color: 'text.secondary',
              fontSize: '0.6875rem',
              fontWeight: 500,
              '& svg': {fontSize: 22},
              '&[aria-current="page"]': {
                color: 'ink.main',
                fontWeight: 600,
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: '30%',
                  right: '30%',
                  height: 3,
                  borderRadius: 2,
                  backgroundColor: 'primary.main',
                },
              },
            }}>
            {item.icon}
            <Box
              component="span"
              sx={{
                maxWidth: '100%',
                px: 0.5,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}>
              {item.shortLabel ?? item.label}
            </Box>
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default BottomNav;
